/** Backend CSRF middleware error payload field. */
export const SessionCsrfErrorCode = {
  ValidationFailed: 'CSRF_VALIDATION_FAILED',
  BadToken: 'EBADCSRFTOKEN',
} as const;

/** Classifies session-related failures for client recovery decisions. */
export enum SessionErrorKind {
  /** Readable/secret CSRF pair is missing or invalid — renew before retry. */
  Csrf = 'csrf',
  /** Access or refresh token is invalid/expired — refresh after CSRF is valid. */
  Unauthenticated = 'unauthenticated',
  /** Authenticated user lacks permission — never logout. */
  Forbidden = 'forbidden',
  /** Network, 5xx, rate limit — retry UI, never logout. */
  Transient = 'transient',
  /** Unrecognized — forward without logout. */
  Unknown = 'unknown',
}
